/** @jsx jsx */
import { jsx, Box, Container, Flex } from 'theme-ui';

// Node Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';

// Node Components
import FluidImage from '@codersclan/gatsby-theme-airfleet/src/components/fluidImage';

// Types
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import TextFrame from '../../components/textFrame';

// Styles
import * as style from './style';

interface LogosSpaceBetweenProps extends Section {
  textarea: {
    textarea?: string;
  };
  logosList: {
    logosList: {
      logoImage: ImageType;
    }[];
  };
}

const LogosSpaceBetween: SectionComponent<LogosSpaceBetweenProps> = ({
  textarea,
  logosList,
}) => (
  <Container sx={style.Container}>
    {textarea?.textarea && (
      <TextFrame content={textarea.textarea} sx={style.Title} />
    )}
    {(logosList?.logosList?.length ?? 0) > 0 && (
      <Flex sx={style.Flex}>
        {logosList?.logosList.map(i => (
          <Box key={i.logoImage.id} sx={style.FlexItem}>
            <FluidImage {...i.logoImage} sx={style.FlexImage} />
          </Box>
        ))}
      </Flex>
    )}
  </Container>
);

export default LogosSpaceBetween;
